export default `
varying vec2 vUv;
uniform float time;
uniform float deltaTime;
uniform vec2 mouse;
uniform bool isMouse;
uniform sampler2D buffer;
uniform vec2 resolution;
uniform float pCount;

#define SEED 0.12345679
#define GRAV vec2(0., -.56)
#define PARTICLES_SIZE 0.024

float rand (vec2 co) {
	highp float a = 12.9898;
	highp float b = 78.233;
	highp float c = 43758.5453;
	highp float dt= dot(co.xy ,vec2(a,b));
	highp float sn= mod(dt,3.14);
	return fract(sin(sn) * c);
}

void main() {
	float asp = resolution.y / resolution.x;
	vec2 anc = vec2(.5, .5 * asp);
	float col = 0.;
	for (float i = 0.0; i < pCount; i++) {
		float ic = i / pCount;
		float ti = ic + time * .1;
		float seed = SEED + floor(ti);
		vec2 velocity = vec2(mix(-.5, .5, rand(vec2(seed, i))), mix(-.5, .5, rand(vec2(i, seed) / 3.)));
		float particleTime = fract(ti);
		float size = (1. - particleTime) * PARTICLES_SIZE;
		vec2 velocityOffset = velocity * particleTime;
		vec2 gravityOffset = GRAV * pow(particleTime, 1.798);
		vec2  offset = velocityOffset + gravityOffset;
		float fade = min(particleTime*30., 1.);
		float mFact = pow(particleTime, 3.);
		vec2 mPoint = vec2(mouse.x, mouse.y * asp);
		float c = 0.;
		vec2 uv1 = gl_FragCoord.xy/resolution.xx;
		#ifdef POSITION_MIDDLE
			vec2 point1 = mix(anc + offset, mPoint, mFact);
			c += smoothstep(size, 0., length(uv1 - point1));
		#endif
		#if defined(POSITION_BOTTOM) || defined(POSITION_TOP)
			vec2 offsetTB = offset * vec2(1., .1);
			float mFactTB = mFact * .5;
		#endif
		#ifdef POSITION_BOTTOM
			vec2 uv2 = uv1 + vec2(0, .2);
			vec2 point2 = mix(vec2(fract(ic*123.) * .25 + .375, anc.y) - offsetTB, mPoint, mFactTB);
			c += smoothstep(size, 0., length(uv2 - point2));
		#endif
		#ifdef POSITION_TOP
			vec2 uv3 = uv1 - vec2(0, .2);
			vec2 point3 = mix(vec2(fract(ic*132.) * .25 + .375, anc.y) + offsetTB, mPoint, mFactTB);
			c += smoothstep(size, 0., length(uv3 - point3));
		#endif
		col += fade * c;
	}
	col = smoothstep(.6, .9, col);
	float buf = texture2D(buffer, vUv).x;
	gl_FragColor = vec4(col, 1., 1., 1.);
}
`